import { differenceInMinutes } from 'date-fns';

import { IOrderInProgressRecentOrder } from 'components/top-service-mode-notification/types';
import { DeliveryStatus, RbiOrderStatus, useGetUserOrdersQuery } from 'generated/graphql-gateway';
import { useAuthContext } from 'state/auth';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

const DELIVERY_COMPLETED = [
  DeliveryStatus.ORDER_DROPPED_OFF,
  DeliveryStatus.ORDER_ABANDONED,
  DeliveryStatus.ORDER_CANCELLED,
];

export const useIsOrderInProgress = (): boolean => {
  const { isAuthenticated } = useAuthContext();
  const notificationExpiredInMinutes = useFlag(LaunchDarklyFlag.TOP_ORDER_STATUS_BAR_TIME_OUT);

  const { data } = useGetUserOrdersQuery({
    variables: {
      limit: 1,
      orderStatuses: [RbiOrderStatus.INSERT_SUCCESSFUL, RbiOrderStatus.UPDATE_SUCCESSFUL],
    },
    skip: !isAuthenticated,
  });

  const recentOrder: IOrderInProgressRecentOrder = data?.userOrders?.orders?.[0];

  const notificationIsExpired =
    recentOrder?.updatedAt &&
    Math.abs(differenceInMinutes(new Date(), new Date(recentOrder.updatedAt))) >
      notificationExpiredInMinutes;

  if (notificationIsExpired) {
    return false;
  }

  const isDeliveryOrderCompleted =
    !!recentOrder?.delivery &&
    recentOrder.delivery.status != null &&
    DELIVERY_COMPLETED.includes(recentOrder.delivery.status);

  // ServiceMode.DELIVERY - ordered
  if (recentOrder?.delivery && !isDeliveryOrderCompleted) {
    return true;
  }
  // PICKUP - ordered
  return !!recentOrder;
};
